var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.68323 8.52724L4.94865 8.22661C5.24983 7.8799 5.52072 7.55094 5.76174 7.23805L5.9607 6.9742C6.79146 5.84906 7.20704 4.95606 7.20704 4.29602C7.20704 2.88717 6.07722 1.74512 4.68323 1.74512C3.28925 1.74512 2.15942 2.88717 2.15942 4.29602C2.15942 4.95606 2.57501 5.84906 3.40577 6.9742L3.60473 7.23805C3.94857 7.68091 4.30831 8.11107 4.68323 8.52766V8.52724Z",
    stroke: "currentColor",
    strokeWidth: 0.739792,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68324 5.33898C5.26402 5.33898 5.73483 4.86572 5.73483 4.28192C5.73483 3.69812 5.26402 3.22485 4.68324 3.22485C4.10246 3.22485 3.63165 3.69812 3.63165 4.28192C3.63165 4.86572 4.10246 5.33898 4.68324 5.33898Z",
    stroke: "currentColor",
    strokeWidth: 0.739792,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineLocation);
export default __webpack_public_path__ + "static/media/line-location.9f618bcb34e1e11fd6a866376b4ca649.svg";
export { ForwardRef as ReactComponent };